import React from 'react';
import '../styles/HeroSection.css';

const HeroSection = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="dot-pattern"></div>
      </div>
      <div className="hero-content">
        <img 
          src="/hero-kate-sewell.png" 
          alt="Kate Sewell Character Art"
          className="hero-image"
        />
      </div>
    </section>
  );
};

export default HeroSection;
